import BaseCollectionService from "./base.collection.service";

class PersonalLiabilityPolicyService extends BaseCollectionService {
  constructor() {
    super("personal-liability-policies");
  }
}

export default new PersonalLiabilityPolicyService();
